// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoMenuItem-module--wrapper--3bPUm","infoItem":"InfoMenuItem-module--info-item--3YgPW","vhrFilterHelpers":"InfoMenuItem-module--vhr-filter-helpers--EAjUy"};